// document.addEventListener('DOMContentLoaded', function() {
//   const popupWrap = document.querySelector('.promo-popup-wrap');
//   const popupTimeout = parseInt(popupWrap.getAttribute('data-popup-timeout'), 10) * 1000;
//   const popupTimes = parseInt(popupWrap.getAttribute('data-popup-times'), 10);
// 	const successMessage = popupWrap.querySelector('.promo-popup-success');
//   const closeButtons = popupWrap.querySelectorAll('.promo-popup-close');
//   const overlay = popupWrap.querySelector('.overlay');
//   const form = popupWrap.querySelector('form');

//   let popupCounter = sessionStorage.getItem('popupCounter') || 0;
//   let formSubmitted = localStorage.getItem('formSubmitted') === 'true';
//   const successMessageIsShown = localStorage.getItem('successMessageIsShown') === 'true';

// 	if (formSubmitted && successMessage && !successMessageIsShown) {
//     openPopup();
//     localStorage.setItem('successMessageIsShown', 'true');
// 	}

//   function openPopup() {
//     popupWrap.style.visibility = 'visible';
//     popupWrap.style.opacity = '1';
//     popupCounter++;
//     sessionStorage.setItem('popupCounter', popupCounter);
//   }

//   function closePopup() {
//     popupWrap.style.visibility = 'hidden';
//     popupWrap.style.opacity = '0';
//   }

//   if (!formSubmitted && popupCounter < popupTimes) {
//     setTimeout(openPopup, popupTimeout);
//   }

// 	if (closeButtons.length) {
// 		closeButtons.forEach( btn => {
// 			btn.addEventListener('click', function() {
//         closePopup();
//       });

// 			btn.addEventListener('keydown', function(event) {
// 				if (event.key === 'Enter' || event.key === ' ') {
// 					closePopup();
// 				}
// 			});
// 		})
// 	}

//   overlay.addEventListener('click', function() {
//     closePopup();
//   });

//   form.addEventListener('submit', function() {
//     localStorage.setItem('formSubmitted', 'true');
//     localStorage.setItem('successMessageIsShown', 'false');
//   });

// 	const addCopyBtn = () => {
// 		const copyBtn = document.querySelector('.promo-popup-discount__copy-btn');
// 		if (!copyBtn) {
// 			return;		
// 		}

// 		const { id } = copyBtn.dataset;
// 		if (!id) {
// 			return;
// 		}

// 		const textElement = document.getElementById(`${id}`);
// 		if (!textElement) {
// 			return;	
// 		}
		
// 		const textToCopy = textElement.innerText;
// 		let timeoutId;
		
// 		copyBtn.addEventListener('click', () => {
// 			if (navigator.clipboard && navigator.clipboard.writeText) {
// 				navigator.clipboard.writeText(textToCopy).then(function () {
// 					copyBtn.classList.add('js-copied');

// 					if (timeoutId) {
// 						clearTimeout(timeoutId);
// 					}

// 					timeoutId = setTimeout(() => {
// 						copyBtn.classList.remove('js-copied');
// 						timeoutId = null; 
// 					}, 3000);
// 				})
// 			}
// 		});
// 	}

// 	addCopyBtn();
// });

document.addEventListener('DOMContentLoaded', function() {
	const popupWrap = document.querySelector('.promo-popup-wrap');
	if (!popupWrap) return;
	
	const popupTimeout = parseInt(popupWrap.getAttribute('data-popup-timeout'), 10) * 1000;
	const popupTimes = parseInt(popupWrap.getAttribute('data-popup-times'), 10);
	const successMessage = popupWrap.querySelector('.promo-popup-success');
	const closeButtons = popupWrap.querySelectorAll('.promo-popup-close');
	const overlay = popupWrap.querySelector('.overlay');
	const form = popupWrap.querySelector('form');
	const focusableSelector = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
	let previouslyFocusedElement = null;
	
	let popupCounter = parseInt(sessionStorage.getItem('popupCounter') || 0, 10);
	let formSubmitted = localStorage.getItem('formSubmitted') === 'true';
	const successMessageIsShown = localStorage.getItem('successMessageIsShown') === 'true';
	
	if (formSubmitted && successMessage && !successMessageIsShown) {
	  openPopup();
	  localStorage.setItem('successMessageIsShown', 'true');
	}
	
	function openPopup() {
	  if (document.querySelector('.jsd-chatbot.is-open')) return;
	  previouslyFocusedElement = document.activeElement;
	  overlay?.classList.remove('hidden');
	  popupWrap.style.visibility = 'visible';
	  popupWrap.style.opacity = '1';
	  popupWrap.setAttribute('aria-hidden', 'false');
	  sessionStorage.setItem('popupCounter', ++popupCounter);
	  window.setTimeout(() => {
		const preferredTarget = popupWrap.querySelector('input[type="email"]') || popupWrap.querySelector(focusableSelector);
		preferredTarget?.focus();
	  });
	}
	
	function closePopup(restoreFocus = true) {
	  popupWrap.style.visibility = 'hidden';
	  popupWrap.style.opacity = '0';
	  popupWrap.setAttribute('aria-hidden', 'true');
	  overlay.classList.add('hidden');
	  if (restoreFocus) previouslyFocusedElement?.focus?.();
	}

	document.addEventListener('jsd:request-close-promo', () => closePopup(false));
	
	if (!formSubmitted && popupCounter < popupTimes) {
	  setTimeout(openPopup, popupTimeout);
	}
	
	if (closeButtons.length) {
	  closeButtons.forEach(btn => {
	  	btn.addEventListener('click', () => closePopup());
	  });
	}

	document.addEventListener('keydown', (event) => {
	  if (popupWrap.getAttribute('aria-hidden') !== 'false') return;

	  if (event.key === 'Escape') {
		event.preventDefault();
		closePopup();
		return;
	  }

	  if (event.key !== 'Tab') return;
	  const focusable = [...popupWrap.querySelectorAll(focusableSelector)]
		.filter((element) => element.offsetWidth || element.offsetHeight || element.getClientRects().length);
	  if (!focusable.length) return;

	  const first = focusable[0];
	  const last = focusable[focusable.length - 1];
	  if (event.shiftKey && document.activeElement === first) {
		event.preventDefault();
		last.focus();
	  } else if (!event.shiftKey && document.activeElement === last) {
		event.preventDefault();
		first.focus();
	  }
	});
	
	if (overlay) {
		overlay.addEventListener('click', () => closePopup());
	}
	
	if (form) {
	  form.addEventListener('submit', function() {
		localStorage.setItem('formSubmitted', 'true');
		localStorage.setItem('successMessageIsShown', 'false');
	  });
	}
	
	function addCopyBtn() {
	  const copyBtn = document.querySelector('.promo-popup-discount__copy-btn');
	  if (!copyBtn) return;

	  const { id } = copyBtn.dataset;
	  if (!id) return;
	  
	  const textElement = document.getElementById(`${id}`);
	  if (!textElement) return;
	  
	  const textToCopy = textElement.innerText;
	  let timeoutId;
	  
	  copyBtn.addEventListener('click', () => {
		if (navigator.clipboard && navigator.clipboard.writeText) {
		  navigator.clipboard.writeText(textToCopy).then(function () {
			copyBtn.classList.add('js-copied');
			
			if (timeoutId) clearTimeout(timeoutId);
			
			timeoutId = setTimeout(() => {
			  copyBtn.classList.remove('js-copied');
			  timeoutId = null;
			}, 3000);
		  });
		}
	  });
	}
	
	addCopyBtn();
  });
